import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  objectiveCompetenciesLength: 0,
  objectiveCompetencies: [],
  objectiveCompetency: {},
  objectiveCompetencyError: "",
  formError: "",
};

export default function ObjectiveCompetencyReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_OBJECTIVE_COMPETENCY:
      return { ...state, loading: action.payload };
    case actions.LOADING_OBJECTIVE_COMPETENCY_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_OBJECTIVE_COMPETENCY:
      return { ...state, saveLoading: action.payload };
    case actions.GET_OBJECTIVE_COMPETENCY:
      return {
        ...state,
        objectiveCompetencies: action.payload.objectiveCompetencies,
        objectiveCompetenciesLength: action.payload.objectiveCompetenciesLength,
      };
    case actions.GET_OBJECTIVE_COMPETENCY_BY_ID:
      return {
        ...state, objectiveCompetency: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.OBJECTIVE_COMPETENCY_FAIL:
      return { ...state, objectiveCompetencyError: action.payload };
    default:
      return state;
  }
}
